import React, { useState, useEffect, useMemo, useCallback } from "react";
import "./LicenseManagement.css";
import { CommonDialogV2 } from "../common/CommonComponents/Dialog";
import { DialogActions, InputAdornment } from "@material-ui/core";
import axios from "axios";
import GenWiz from "../common/Popups/Genwizui";
import { CSVLink } from "react-csv";
import {
  StyledSearchBarPlatforms,
  StyledSearchIcon,
} from "../fui/FuiStyles";
import base from '../../config';

//  License management dashboard
//  * @author Ganesh Gugulothu
//  * @version 1.0
const LicenseManagement = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [isSendMailVisible, setSendMailVisible] = useState(false);
  const [isEditVisible, setEditVisible] = useState(false);
  const [isDeleteVisible, setDeleteVisible] = useState(false);
  const [licenseData, setLicenseData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [sortConfig, setSortConfig] = useState({ field: 'customer_name', asc: true });

  const handleSort = (field) => {
    setSortConfig(prev => ({
      field,
      asc: prev.field === field ? !prev.asc : true,
    }));
  };
  const [isloading, setisloading] = useState(false);
  const [gwconfig, setgenwiz] = useState({ stateFunction: setgenwiz });
  const [additionalCc, setAdditionalCc] = useState("");
  const [orderId, setOrderId] = useState("");
  const [isCancelVisible, setCancelVisible] = useState(false);
  const [cancelStatus, setCancelStatus] = useState("");
  const [editFields, setEditFields] = useState({
    customer_name: "",
     project_name: "",
    sap_contract_id: "",
    tenant_type: "",
    user_email: "",
    wbse_code: "",
    licencepoc: "",
    new_licence_capacity_gb: "",
    notes: ""
  });

  // Capacity dropdown options
  const capacityOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  const [notesUpdatedByUser, setNotesUpdatedByUser] = useState(false);

  const isCapacityChanged = Boolean(editFields.new_licence_capacity_gb && editFields.new_licence_capacity_gb !== "");
  // Notes are considered "updated" if the current value differs from the original saved notes
  const isNotesUpdated = (editFields.notes || "").trim() !== (editFields._existingNotes || "").trim();
  const isNotesMissing = isCapacityChanged && !isNotesUpdated;
  const isSaveDisabled = isNotesMissing;

  // Calculate license usage statistics
  const licenseStats = useMemo(() => {
    const activeLicenses = licenseData.filter(license =>
      (license.status || "").toLowerCase() === 'active'
    );

    const inactiveLicenses = licenseData.filter(license => {
      const status = (license.status || "").toLowerCase();
      return status === 'inactive' || status === 'deactive';
    });

    // CHANGED: filter from activeLicenses only (not all licenseData)
    const activeLicensesWithoutWBSE = activeLicenses.filter(license =>
      !license.wbse_code || (license.wbse_code || "").trim() === ''
    );

    // CHANGED: filter from activeLicenses only (not all licenseData)
    const activeLicensesWithoutContractID = activeLicenses.filter(license =>
      !license.sap_contract_id || (license.sap_contract_id || "").trim() === ''
    );

    // REMOVED: licensesWithoutlicencepoc — no longer needed

    const licensesWithNotes = licenseData.filter(license =>
      license.notes && (license.notes || "").trim() !== ''
    );

    const getCapacity = (license) => parseInt(license.new_licence_capacity_gb || license.licence_capacity_gb) || 0;

    const totalCapacityActive = activeLicenses.reduce((total, license) =>
      total + getCapacity(license), 0
    );

    const totalCapacityAll = licenseData.reduce((total, license) =>
      total + getCapacity(license), 0
    );

    return {
      totalLicenses: licenseData.length,
      activeLicenses: activeLicenses.length,
      inactiveLicenses: inactiveLicenses.length,
      totalCapacityActive,
      totalCapacityAll,
      activePercentage: licenseData.length > 0 ? Math.round((activeLicenses.length / licenseData.length) * 100) : 0,
      activeLicensesWithoutWBSE: activeLicensesWithoutWBSE.length,
      activeLicensesWithoutContractID: activeLicensesWithoutContractID.length,
      // REMOVED: licensesWithoutlicencepoc
      licensesWithNotes: licensesWithNotes.length,
      activeLicensesWithoutWBSEData: activeLicensesWithoutWBSE,
      activeLicensesWithoutContractIDData: activeLicensesWithoutContractID,
      // REMOVED: licensesWithoutlicencepocData
    };
  }, [licenseData]);

  const formatDate = () => {
    const now = new Date();
    return now.toISOString().replace(/[:.]/g, "-");
  };

  const onload = () => {
    const idToken = localStorage.getItem("token");
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Fetching Data',
      }
    });
    axios.get(`${base.app.apiSite}dashboard/splunk-license/read/all`, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }).then((response) => {
      setLicenseData(response.data);
      setgenwiz({});
      setisloading(false);
    }).catch((error) => {
      console.error("Error fetching license data:", error);
      setgenwiz({});
      setisloading(false);
    });
  };

  useEffect(() => {
    onload();
    setisloading(true);
  }, []);

  // Reset to page 1 whenever search query changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const hideTMenu = () => {
    const alldiv = document.getElementsByClassName('table-menu');
    for (var i = 0, len = alldiv.length; i < len; i++) {
      alldiv[i].style["display"] = 'none';
    }
  };

  const tableButton = (evt) => {
    evt.stopPropagation();
    const curdiv = evt.target.closest("td").querySelector(".table-menu");
    if (curdiv.style.display === "block") {
      curdiv.style.display = "none";
    } else {
      const alldiv = document.getElementsByClassName("table-menu");
      for (let i = 0; i < alldiv.length; i++) alldiv[i].style.display = "none";
      curdiv.style.display = "block";
    }
  };

  const handleSendMail = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setOrderId(license.sap_contract_id || "");
    // Set licensePoc email in CC by default
    setAdditionalCc(license.licencepoc || "");
    setSendMailVisible(true);
  };

  const handleLicenseCancel = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setCancelStatus(license.status || "Active");
    setCancelVisible(true);
  };

  const toggleLicense = (licenseStatus, Notes) => {
    const idToken = localStorage.getItem("token");
    const postData = {
      "ID": selectedLicense.id,
      "Status": licenseStatus,
      "Notes": Notes,
    };
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    const urlparams = new URLSearchParams(postData).toString();
    const url = `${base.app.apiSite}dashboard/splunk-license/update/status?` + urlparams;
    axios.post(url, postData, urloptions).then((resp) => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Database Updated',
          callback: () => { onload(); }
        }
      });
    }).catch((err) => { console.log(err); });
  };

  const sendMail = async () => {
    const mainEmail = ((selectedLicense && selectedLicense.user_email) || "").trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!mainEmail) {
      alert("Recipient email is required.");
      return;
    }
    if (!emailRegex.test(mainEmail)) {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Recipient email is invalid!',
        }
      });
      return;
    }

    const ccEmails = additionalCc
      .split(",")
      .map(email => email.trim())
      .filter(email => email.length > 0);

    const invalidCc = ccEmails.find(email => !emailRegex.test(email));
    if (invalidCc) {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: `Invalid CC email: ${invalidCc}`,
        }
      });
      return;
    }
    
    const idToken = localStorage.getItem("token");
    const datalist = {
      id: selectedLicense.id,
      cc: additionalCc,
      emailto: mainEmail
    };
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };

    const urlparams = new URLSearchParams(datalist).toString();
    const url = `${base.app.apiSite}dashboard/splunk-license/resend/email/?` + urlparams;

    setSendMailVisible(false);

    axios.post(url, datalist, urloptions).then((resp) => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Mail sent successfully!',
        }
      });
    }).catch(() => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Failed to send mail',
        }
      });
    });
  };

  const editData = () => {
    // Notes must be changed/updated when capacity is modified
    if (isCapacityChanged && !isNotesUpdated) {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Please update the Notes field to describe the reason for the capacity change!',
        }
      });
      return;
    }

    const licenseId = selectedLicense && selectedLicense.id;
    const idToken = localStorage.getItem("token");
    const url = `${base.app.apiSite}dashboard/splunk-license/update/${licenseId}`;

    const fieldsToUpdate = { ...editFields };

    // Remove internal tracking field — never send to API
    delete fieldsToUpdate._existingNotes;

    if (isCapacityChanged) {
      // Set the new capacity value chosen by the user
      fieldsToUpdate.licence_capacity_gb = fieldsToUpdate.new_licence_capacity_gb;
    } else {
      delete fieldsToUpdate.new_licence_capacity_gb;
    }

    const payload = { id: licenseId, fields: fieldsToUpdate };
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };

    setEditVisible(false);

    axios.post(url, payload, urloptions).then((resp) => {
      setEditFields({
        customer_name: "",
        project_name: "",
        sap_contract_id: "",
        tenant_type: "",
        user_email: "",
        wbse_code: "",
        licencepoc: "",
        new_licence_capacity_gb: "",
        notes: ""
      });
      onload();

      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'License updated successfully!',
        }
      });
    }).catch(() => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Failed to update license.',
        }
      });
    });
  };

  const inactivateLicense = (license) => {
    setSelectedLicense(license);
    hideTMenu();
    setgenwiz({
      appName: 'gwConfirm',
      config: {
        stateFunction: setgenwiz,
        text: 'Deactivate the License?',
        onloop: true,
        bntYes: () => {
          setgenwiz({
            appName: 'gwInput',
            config: {
              height: 'auto',
              stateFunction: setgenwiz,
              text: 'User Notes',
              type: 'textarea',
              bntSubmit: async (data) => { toggleLicense("inactive", data); }
            },
          });
        }
      },
    });
  };

  const activateLicense = (license) => {
    setSelectedLicense(license);
    hideTMenu();
    setgenwiz({
      appName: 'gwConfirm',
      config: {
        stateFunction: setgenwiz,
        text: 'Activate the License?',
        onloop: true,
        bntYes: () => {
          setgenwiz({
            appName: 'gwInput',
            config: {
              height: 'auto',
              stateFunction: setgenwiz,
              text: 'User Notes',
              type: 'textarea',
              bntSubmit: async (data) => { toggleLicense("active", data); }
            },
          });
        }
      },
    });
  };

  const handleEdit = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setEditFields({
      customer_name: license.customer_name || "",
      project_name: license.project_name || "", 
      sap_contract_id: license.sap_contract_id || "",
      tenant_type: license.tenant_type || "",
      user_email: license.user_email || "",
      wbse_code: license.wbse_code || "",
      licencepoc: license.licencepoc || "",
      new_licence_capacity_gb: "",
      notes: license.notes || "",  
      _existingNotes: license.notes || ""  
    });
    setNotesUpdatedByUser(false);
    setEditVisible(true);
  };

  const handleDelete = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setDeleteVisible(true);
  };

  const handleDetailsClick = (license) => {
    hideTMenu();
    setSelectedLicense(license);
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
    setSelectedLicense(null);
  };

  const filteredLicenses = licenseData
    .filter((license) => {
      const query = searchQuery.toLowerCase();
      return (
        (license.id || "").toString().includes(query) ||
        (license.customer_name || "").toLowerCase().includes(query) ||
        (license.sap_contract_id || "").toLowerCase().includes(query) ||
        (license.user_email || "").toLowerCase().includes(query) ||
        (license.ProvisionedBy || "").toLowerCase().includes(query) ||
        (license.licencepoc || "").toLowerCase().includes(query) ||
        (license.wbse_code || "").toLowerCase().includes(query) ||
        (license.status || "").toLowerCase().includes(query) ||
        (license.tenant_type || "").toLowerCase().includes(query) ||
        (license.environment || "").toLowerCase().includes(query) ||
        (license.new_licence_capacity_gb || license.licence_capacity_gb || "").toString().includes(query) ||
        (license.licence_order_id || "").toLowerCase().includes(query) ||
        (license.date_created || "").includes(query) ||
        (license.licence_date_expires || "").includes(query) ||
        (license.notes || "").toLowerCase().includes(query)
      );
    })
    .sort(function (a, b) {
      const { field, asc } = sortConfig;
      let valA, valB;

      switch (field) {
        case 'customer_name':
          valA = (a.customer_name || "").toLowerCase();
          valB = (b.customer_name || "").toLowerCase();
          break;
        case 'provisioned_by':
          valA = (a.ProvisionedBy || "").toLowerCase();
          valB = (b.ProvisionedBy || "").toLowerCase();
          break;
        case 'license_poc':
          valA = (a.licencepoc || "").toLowerCase();
          valB = (b.licencepoc || "").toLowerCase();
          break;
        case 'capacity':
          valA = parseInt(a.new_licence_capacity_gb || a.licence_capacity_gb) || 0;
          valB = parseInt(b.new_licence_capacity_gb || b.licence_capacity_gb) || 0;
          return asc ? valA - valB : valB - valA;
        case 'wbse':
          valA = (a.wbse_code || "").toLowerCase();
          valB = (b.wbse_code || "").toLowerCase();
          break;
        case 'status':
          valA = (a.status || "").toLowerCase();
          valB = (b.status || "").toLowerCase();
          break;
        default:
          return 0;
      }

      if (valA < valB) return asc ? -1 : 1;
      if (valA > valB) return asc ? 1 : -1;
      return 0;
    });

  const csvHeaders = [
    { label: "Customer Name", key: "customer_name" },
    { label: "Project Name", key: "project_name" },
    { label: "ProvisionedBy", key: "user_email" },
    { label: "Project License PoC", key: "licencepoc" },
    { label: "Contract ID", key: "sap_contract_id" },
    { label: "Initial Request Date", key: "date_created" },
    { label: "Capacity (GB)", key: "_capacity_display" },
    { label: "Date Expires", key: "licence_date_expires" },
    { label: "WBSE", key: "wbse_code" },
    { label: "Environment", key: "environment" },
    { label: "Dynamo DB ID", key: "id" },
    { label: "License Renewal Date", key: "licence_date_created" },
    { label: "License Expiry Date", key: "licence_date_expires" },
    { label: "License Order ID", key: "licence_order_id" },
    { label: "Tenant Type", key: "tenant_type" },
    { label: "License Status", key: "status" },
    { label: "User Notes", key: "notes" },
    { label: "New Capacity (GB)", key: "new_licence_capacity_gb" }
  ];

  // Normalize capacity for CSV
  var normalizeCsvData = function(dataArr) {
    return dataArr.map(function(license) {
      var hasNewCapacity = license.new_licence_capacity_gb &&
        license.new_licence_capacity_gb !== license.licence_capacity_gb;
      return Object.assign({}, license, {
        _capacity_display: license.licence_capacity_gb || "",
        new_licence_capacity_gb: hasNewCapacity ? license.new_licence_capacity_gb : ""
      });
    });
  };

  const csvData = normalizeCsvData(filteredLicenses);
  // CHANGED: active-only filtered CSV data for WBSE and Contract ID
  const csvDataActiveWBSE = normalizeCsvData(licenseStats.activeLicensesWithoutWBSEData);
  const csvDataActiveContractID = normalizeCsvData(licenseStats.activeLicensesWithoutContractIDData);
  // REMOVED: csvDataLicencePoc

  const totalPages = Math.ceil(filteredLicenses.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedLicenses = filteredLicenses.slice(startIndex, endIndex);

  const selectedStatus = ((selectedLicense && selectedLicense.status) || "").toLowerCase();
  // Shared styles for greyed-out (disabled) menu items
  const disabledMenuItemStyle = {
    color: "#bbb",
    cursor: "not-allowed",
    pointerEvents: "none",
    userSelect: "none",
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", alignItems: 'center', padding: "0px 10px", position: 'relative' }}>
        <StyledSearchBarPlatforms
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          id="outlined-search"
          type="search"
          margin="normal"
          placeholder="Search filter"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <StyledSearchIcon />
              </InputAdornment>
            ),
          }}
          style={{ borderRadius: '30px' }}
        />
        <div style={{ position: 'absolute', top: '25px', right: '-15px', padding: "5px 20px", height: "40px" }}>
          <CSVLink
            headers={csvHeaders}
            data={csvData}
            filename={`SplunkLicenseExport_${formatDate()}.csv`}
            onClick={() => {
              setgenwiz({
                appName: 'gwAlert',
                config: {
                  stateFunction: setgenwiz,
                  text: 'Downloading License Data',
                }
              });
            }}
            style={{
              padding: "8px", backgroundColor: "#7500C0", color: "#fff", textDecoration: "none", borderRadius: "4px",
            }}
          >
            Download CSV
          </CSVLink>
        </div>
      </div>

      {/* License Usage Statistics Dashboard */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px 10px",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        margin: "10px 0",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
      }}>
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#7500C0" }}>{licenseStats.totalLicenses}</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Total Licenses</div>
          </div>
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#28a745" }}>{licenseStats.activeLicenses}</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Active Licenses</div>
          </div>
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#dc3545" }}>{licenseStats.inactiveLicenses}</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Deactive Licenses</div>
          </div>
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#17a2b8" }}>{licenseStats.totalCapacityActive} GB</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Active Capacity</div>
          </div>
          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#ffc107" }}>{licenseStats.activePercentage}%</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Active Rate</div>
          </div>

          {/* CHANGED: Active Missing WBSE (active licenses only) */}
          <div style={{ textAlign: "center", padding: "10px 15px", cursor: "pointer" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#e74c3c" }}>{licenseStats.activeLicensesWithoutWBSE}</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Active Missing WBSE</div>
            <CSVLink
              headers={csvHeaders}
              data={csvDataActiveWBSE}
              filename={`Active_Licenses_Without_WBSE_${formatDate()}.csv`}
              style={{ fontSize: "10px", color: "#007bff", textDecoration: "underline" }}
            >
              Download
            </CSVLink>
          </div>

          {/* CHANGED: Active Missing Contract ID (active licenses only) */}
          <div style={{ textAlign: "center", padding: "10px 15px", cursor: "pointer" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#e67e22" }}>{licenseStats.activeLicensesWithoutContractID}</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>Active Missing Contract ID</div>
            <CSVLink
              headers={csvHeaders}
              data={csvDataActiveContractID}
              filename={`Active_Licenses_Without_ContractID_${formatDate()}.csv`}
              style={{ fontSize: "10px", color: "#007bff", textDecoration: "underline" }}
            >
              Download
            </CSVLink>
          </div>

          {/* REMOVED: Missing License PoC stat block */}

          <div style={{ textAlign: "center", padding: "10px 15px" }}>
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "#9b59b6" }}>{licenseStats.licensesWithNotes}</div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>With Notes</div>
          </div>
        </div>
      </div>

      {/* License Table */}
      <table className="licensedata">
        <thead>
          <tr>
            <th
              style={{ cursor: "pointer", textDecoration: sortConfig.field === 'customer_name' ? "underline" : "none" }}
              onClick={() => handleSort('customer_name')}
            >
              Client Name {sortConfig.field === 'customer_name' && (sortConfig.asc ? '↑' : '↓')}
            </th>
            <th style={{ minWidth: "140px" }}>Project Name</th>
            <th
              style={{ cursor: "pointer", textDecoration: sortConfig.field === 'provisioned_by' ? "underline" : "none", minWidth: "200px" }}
              onClick={() => handleSort('provisioned_by')}
            >
              ProvisionedBy {sortConfig.field === 'provisioned_by' && (sortConfig.asc ? '↑' : '↓')}
            </th>
            <th>Contract ID</th>
            <th
              style={{ cursor: "pointer", textDecoration: sortConfig.field === 'license_poc' ? "underline" : "none", minWidth: "150px" }}
              onClick={() => handleSort('license_poc')}
            >
              Project License PoC {sortConfig.field === 'license_poc' && (sortConfig.asc ? '↑' : '↓')}
            </th>
            <th>Initial Request Date</th>
            <th
              style={{ cursor: "pointer", textDecoration: sortConfig.field === 'capacity' ? "underline" : "none" }}
              onClick={() => handleSort('capacity')}
            >
              Capacity {sortConfig.field === 'capacity' && (sortConfig.asc ? '↑' : '↓')}
            </th>
            <th>Date Expires</th>
            <th
              style={{ cursor: "pointer", textDecoration: sortConfig.field === 'wbse' ? "underline" : "none" }}
              onClick={() => handleSort('wbse')}
            >
              WBSE {sortConfig.field === 'wbse' && (sortConfig.asc ? '↑' : '↓')}
            </th>
            <th
              style={{ cursor: "pointer", textDecoration: sortConfig.field === 'status' ? "underline" : "none" }}
              onClick={() => handleSort('status')}
            >
              License Status {sortConfig.field === 'status' && (sortConfig.asc ? '↑' : '↓')}
            </th>
            <th style={{ minWidth: "150px" }}>Notes</th>
            <th style={{ width: "100px" }}>Action</th>
          </tr>
        </thead>
        <tbody className={isloading && 'skeleton'}>
          {isloading ? (
            Array.from({ length: 10 }).map((_, i) => (
              <tr key={i}>
                {Array.from({ length: 11 }).map((_, j) => (
                  <td key={j}><span>0000000000</span></td>
                ))}
              </tr>
            ))
          ) : (
            paginatedLicenses.map((license, index) => {
              const licenseStatus = (license.status || "").toLowerCase();
              const isActive = licenseStatus === 'active';
              const contractMissing = !license.sap_contract_id || (license.sap_contract_id || "").trim() === '';
              const pocMissing = !license.licencepoc || (license.licencepoc || "").trim() === '';
              const wbseMissing = !license.wbse_code || (license.wbse_code || "").trim() === '';

              return (
                <tr key={index}>
                  <td>{license.customer_name}</td>
                  <td style={{ maxWidth: "140px", wordWrap: "break-word", wordBreak: "break-word", whiteSpace: "normal", lineHeight: "1.4" }}>
                    {license.project_name || <span style={{ color: '#6c757d', fontStyle: 'italic' }}>—</span>}
                  </td>
                  <td style={{ maxWidth: "200px", wordWrap: "break-word", wordBreak: "break-word", whiteSpace: "normal", lineHeight: "1.4" }}>
                    {license.user_email}
                  </td>
                  <td style={{ color: contractMissing ? '#dc3545' : 'inherit' }}>
                    {license.sap_contract_id || 'Missing'}
                  </td>
                  <td style={{ maxWidth: "200px", wordWrap: "break-word", wordBreak: "break-word", whiteSpace: "normal", lineHeight: "1.4", color: pocMissing ? '#dc3545' : 'inherit' }}>
                    {license.licencepoc || 'Missing'}
                  </td>
                  <td>{(license.date_created || "").split("T")[0]}</td>
                  <td>{(license.new_licence_capacity_gb || license.licence_capacity_gb)}GB</td>
                  <td>{(license.licence_date_expires || "").split("T")[0]}</td>
                  <td style={{ color: wbseMissing ? '#dc3545' : 'inherit' }}>
                    {license.wbse_code || 'Missing'}
                  </td>
                  <td>
                    <span style={{
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      backgroundColor: isActive ? '#d4edda' : '#f8d7da',
                      color: isActive ? '#155724' : '#721c24'
                    }}>
                      {license.status || '—'}
                    </span>
                  </td>
                  <td style={{ maxWidth: "150px", wordWrap: "break-word", wordBreak: "break-word", whiteSpace: "normal", fontSize: "12px", lineHeight: "1.3" }}>
                    {license.notes ? (
                      <div title={license.notes}>
                        {license.notes.length > 50 ? `${license.notes.substring(0, 50)}...` : license.notes}
                      </div>
                    ) : (
                      <span style={{ color: '#6c757d', fontStyle: 'italic' }}>No notes</span>
                    )}
                  </td>
                  <td style={{ position: 'relative' }}>
                    <button type="button" onClick={(evt) => tableButton(evt)}></button>
                    <div className="table-menu" style={{ display: "none" }}>
                      <div className="tri"></div>
                      <ul>
                        {/* Details — always available */}
                        <li onClick={() => handleDetailsClick(license)}>Details</li>
                        <li
                          onClick={isActive ? () => handleEdit(license) : undefined}
                          style={!isActive ? disabledMenuItemStyle : {}}
                          title={!isActive ? "Only available for active licenses" : ""}
                        >
                          Edit
                          {!isActive && (
                            <span style={{ fontSize: "10px", marginLeft: "6px", color: "#bbb" }}>(inactive)</span>
                          )}
                        </li>
                        <li
                          onClick={isActive ? () => handleSendMail(license) : undefined}
                          style={!isActive ? disabledMenuItemStyle : {}}
                          title={!isActive ? "Only available for active licenses" : ""}
                        >
                          Send Mail
                          {!isActive && (
                            <span style={{ fontSize: "10px", marginLeft: "6px", color: "#bbb" }}>(inactive)</span>
                          )}
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {/* Details Popup */}
      {popupVisible && selectedLicense && (
        <CommonDialogV2
          open={popupVisible}
          onClose={handleClosePopup}
          width='480px'
          title={<div>License Details</div>}
          textContent={
            <div style={{ padding: "15px 5px" }}>
              <table style={{ width: '100%' }}>
                <tbody>
                  {[
                    { label: "Dynamo DB", value: selectedLicense.licence_id },
                    { label: "Customer", value: selectedLicense.customer_name },
                    { label: "Project Name", value: selectedLicense.project_name },
                    { label: "Environment", value: selectedLicense.environment },
                    { label: "Contract ID", value: selectedLicense.sap_contract_id },
                    { label: "Order ID", value: selectedLicense.licence_order_id },
                    { label: "Renewal Date", value: (selectedLicense.licence_date_created || "").replace(/[TZ]/g, ' ') },
                    { label: "Expiry Date", value: (selectedLicense.licence_date_expires || "").replace(/[TZ]/g, ' ') },
                    { label: "License ID", value: selectedLicense.licence_id },
                    { label: "Capacity", value: (selectedLicense.new_licence_capacity_gb || selectedLicense.licence_capacity_gb) != null ? (selectedLicense.new_licence_capacity_gb || selectedLicense.licence_capacity_gb) + 'GB' : '—' },
                    { label: "Tenant Type", value: selectedLicense.tenant_type },
                    { label: "ProvisionedBy", value: selectedLicense.ProvisionedBy },
                    { label: "Project License PoC", value: selectedLicense.licencepoc },
                    { label: "WBSE", value: selectedLicense.wbse_code },
                    { label: "Notes", value: selectedLicense.notes },
                  ].map((item, idx) => (
                    <tr key={idx} style={{ padding: '10px 5px', fontSize: "15px" }}>
                      <td style={{ fontWeight: "600", width: '140px' }}>{item.label}:</td>
                      <td style={{ width: 'auto', wordWrap: "break-word", wordBreak: "break-word", whiteSpace: "normal" }}>
                        {item.value || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          }
          dialogActions={
            <DialogActions style={{ padding: "8px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {/* Edit button in Details popup also respects active-only rule */}
              <button
                onClick={() => {
                  if (selectedStatus !== 'active') return;
                  handleClosePopup();
                  handleEdit(selectedLicense);
                }}
                disabled={selectedStatus !== 'active'}
                title={selectedStatus !== 'active' ? "Only available for active licenses" : ""}
                style={{
                  padding: "8px 16px",
                  backgroundColor: selectedStatus !== 'active' ? "#ccc" : "blueviolet",
                  color: selectedStatus !== 'active' ? "#888" : "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: selectedStatus !== 'active' ? "not-allowed" : "pointer",
                  width: '100px'
                }}
              >
                Edit
              </button>
              <button
                onClick={() => {
                  handleClosePopup();
                  if (selectedStatus === 'active')
                    inactivateLicense(selectedLicense);
                  else
                    activateLicense(selectedLicense);
                }}
                style={{ padding: "8px 16px", backgroundColor: "blueviolet", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", width: '100px' }}
              >
                {selectedStatus === 'active' ? "Deactivate" : "Activate"}
              </button>
              <button
                onClick={handleClosePopup}
                style={{ padding: "8px 16px", backgroundColor: "blueviolet", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", width: '100px' }}
              >
                Close
              </button>
            </DialogActions>
          }
        />
      )}

      {/* Send Mail Dialog */}
      <CommonDialogV2
        open={isSendMailVisible}
        onClose={() => setSendMailVisible(false)}
        title={"Send Mail"}
        textContent={
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <label><strong>Additional CC:</strong></label>
            <input
              type="email"
              value={additionalCc}
              onChange={(e) => setAdditionalCc(e.target.value)}
              placeholder="e.g. <user1-mail-id>, <user1-mail-id>"
              style={{ width: "95%", padding: "10px", marginTop: "6px" }}
            />
            <small style={{ color: "#666", fontSize: "12px", marginTop: "4px", display: "block" }}>
              Multiple emails separated with commas. Project License PoC email is auto-included.
            </small>
          </div>
        }
        dialogActions={
          <DialogActions>
            <button onClick={() => sendMail()} style={{ width: '80px', padding: "8px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", marginRight: "5px" }}>Send Mail</button>
            <button onClick={() => setSendMailVisible(false)} style={{ width: '80px', padding: "8px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", marginRight: "15px" }}>Close</button>
          </DialogActions>
        }
      />

      {/* Edit Dialog */}
      <CommonDialogV2
        open={isEditVisible}
        onClose={() => setEditVisible(false)}
        title={"Edit License"}
        width="420px"
        textContent={
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {Object.entries(editFields).map(([key, value]) => {
              // Internal tracking field — never render as a form input
              if (key === "_existingNotes") return null;

              let label = key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
              if (key === "sap_contract_id") label = "Contract ID";
              if (key === "project_name") label = "Project Name";
              if (key === "user_email") label = "ProvisionedBy";
              if (key === "wbse_code") label = "WBSE";
              if (key === "licencepoc") label = "Project License PoC";
              if (key === "new_licence_capacity_gb") label = "New Capacity (GB)";
              if (key === "notes") label = "Notes";

              return (
                <div key={key}>
                  <label style={{ fontWeight: '500' }}>
                    {label}
                    {/* FIX 1 (UI): Red asterisk on Notes label when capacity is selected */}
                    {key === "notes" && isCapacityChanged && (
                      <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                    )}
                  </label>
                  {key === "new_licence_capacity_gb" ? (
                    <select
                      value={value}
                      onChange={(e) => setEditFields({ ...editFields, [key]: e.target.value })}
                      style={{ width: "98%", padding: "10px", marginTop: "6px", border: '1px solid #E5E5E5', borderRadius: '3px', backgroundColor: '#fff' }}
                    >
                      <option value="">-- Select New Capacity --</option>
                      {capacityOptions.map((capacity) => (
                        <option key={capacity} value={capacity}>{capacity} GB</option>
                      ))}
                    </select>
                  ) : key === "notes" ? (
                    <>
                      {/* Show previous notes as read-only reference when capacity is being changed */}
                      {isCapacityChanged && editFields._existingNotes && (
                        <div style={{
                          marginTop: "6px",
                          padding: "8px 10px",
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #dee2e6",
                          borderRadius: "3px",
                          fontSize: "11px",
                          color: "#6c757d",
                          lineHeight: "1.4"
                        }}>
                          <span style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Previous notes:</span>
                          {editFields._existingNotes}
                        </div>
                      )}
                      <textarea
                        value={value}
                        onChange={(e) => {
                          setEditFields({ ...editFields, [key]: e.target.value });
                        }}
                        placeholder="Example: Requested by CAM team | 03/04 - updated to 3GB as per RITM123"
                        style={{
                          width: "95%",
                          padding: "10px",
                          marginTop: "6px",
                          border: isNotesMissing ? '1px solid #dc3545' : '1px solid #E5E5E5',
                          borderRadius: '3px',
                          minHeight: "80px",
                          fontFamily: "inherit"
                        }}
                        rows={3}
                      />
                    </>
                  ) : (
                    <input
                      type="text"
                      value={value}
                      onChange={(e) => setEditFields({ ...editFields, [key]: e.target.value })}
                      placeholder={
                        key === "user_email" ? "e.g. <user1-mail-id>, <user2-mail-id>"
                          : key === "licencepoc" ? "e.g. <user1-mail-id>, <user2-mail-id>"
                          : `Enter ${label}`
                      }
                      style={{ width: "95%", padding: "10px", marginTop: "6px", border: '1px solid #E5E5E5', borderRadius: '3px' }}
                    />
                  )}
                  {key === "licencepoc" && (
                    <small style={{ color: "#666", fontSize: "11px", marginTop: "4px", display: "block", lineHeight: "1.3" }}>
                      License email (Project/Team DL preferred)
                    </small>
                  )}
                  {/* FIX 1 (UI): Show mandatory warning below Notes when capacity is selected */}
                  {key === "notes" && isCapacityChanged && (
                    <small style={{ color: "#d9534f", fontSize: "11px", marginTop: "4px", display: "block", lineHeight: "1.3", fontWeight: "500" }}>
                      Notes are mandatory when modifying capacity!
                    </small>
                  )}
                </div>
              );
            })}
          </div>
        }
        dialogActions={
          <DialogActions>
            {/* FIX 1 (UI): Save button is disabled + greyed out when notes are missing after capacity change */}
            <button
              onClick={() => editData()}
              disabled={isSaveDisabled}
              title={isSaveDisabled ? "Please add notes before saving a capacity change" : ""}
              style={{
                width: '80px',
                padding: "8px 16px",
                backgroundColor: isSaveDisabled ? "#ccc" : "#7500C0",
                color: isSaveDisabled ? "#888" : "#fff",
                border: "none",
                borderRadius: "4px",
                marginRight: "8px",
                cursor: isSaveDisabled ? "not-allowed" : "pointer",
              }}
            >
              Save
            </button>
            <button
              onClick={() => setEditVisible(false)}
              style={{ width: '80px', padding: "8px 16px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px" }}
            >
              Cancel
            </button>
          </DialogActions>
        }
      />

      <GenWiz open={true} appconfig={gwconfig} />

      {totalPages > 1 &&
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "20px 30px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{ padding: "6px 12px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
            >
              Prev
            </button>
            <span style={{ margin: "0 8px" }}>Page {currentPage} of {totalPages}</span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={{ padding: "6px 12px", backgroundColor: "#7500C0", color: "#fff", border: "none", borderRadius: "4px", cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
            >
              Next
            </button>
          </div>
        </div>
      }
    </>
  );
};
export default LicenseManagement;